import React, { useEffect, useState } from "react";
import { Category, getCategories } from "../../api/categories";
import { useAuth } from "../../context/AuthContext";
import { styled } from "../../stitches.config";

import { bodyLarge, h2 } from "../commonStyles/Fonts";

import DashboardHeader from "../DashboardHeader";
import ToggleButton from "../ToggleButton";
import DashboardModal, { DashboardModalType } from "./DashboardModal";

const DashboardWatched: React.FC = () => {
  const [{ user }, dispatch] = useAuth();
  const [modalType, setModalType] = useState<DashboardModalType | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);
  const [isAllIgnore, setIsAllIgnore] = useState(false);

  useEffect(() => {
    getCategories().then((data) => setCategories(data));
  }, []);
  const toggleDarkMode = () => {
    dispatch({
      type: "update_user",
      // @ts-ignore
      payload: {
        ...user,
        settings: { ...user!.settings, dark_mode: !user!?.settings.dark_mode },
      },
    });
  };
  const toggleNewsletter = () => {
    dispatch({
      type: "update_user",
      // @ts-ignore
      payload: {
        ...user,
        settings: {
          ...user!.settings,
          newsletter: !user!?.settings.newsletter,
        },
      },
    });
  };

  const onToggleIgnored = (id: string) => {
    setIsAllIgnore(false);
    const addOrRemove = (array: string[], value: string) => {
      var index = array.indexOf(value);

      if (index === -1) {
        array.push(value);
      } else {
        array.splice(index, 1);
      }
      return array.map((str) => str);
    };

    dispatch({
      type: "update_user",
      // @ts-ignore
      payload: {
        ...user,
        settings: {
          ...user!.settings,
          ignored_categories: addOrRemove(
            user?.settings.ignored_categories ?? [],
            id
          ),
        },
      },
    });
  };

  const onRemoveIgnores = () => {
    setIsAllIgnore(true);
    dispatch({
      type: "update_user",
      // @ts-ignore
      payload: {
        ...user,
        settings: {
          ...user!.settings,
          ignored_categories: [],
        },
      },
    });
  };

  return (user && user?.settings &&
    <>
      {/* {modalType && (
        <DashboardModal
          key={`ignoreModal_${isAllIgnore}`}
          type={DashboardModalType.MAIN_SETTINGS}
          onCloseBtn={() => setModalType(null)}
          onRemoveIgnores={onRemoveIgnores}
        >
          {categories.map(({ name, OID }) => (
            <ToggleButton
              text={name}
              active={!user?.settings.ignored_categories.includes(OID) ?? true}
              onToggle={() => onToggleIgnored(OID)}
            />
          ))}
        </DashboardModal>
      )} */}
      <StyledDashboardWrapper id="personalizacja">
        <h2 className={h2()}>Personalizacja</h2>
        <p className={bodyLarge()}>
          Zmieniaj na:Temat tak, aby najlepiej Ci się korzystało i czytało nasze
          treści. <br /> Dostosuj treści, które widzisz i ich kolejnośc, zmień
          kolor portalu i widoczność reklam.
        </p>
        {/* @todo oprogramować
        <DashboardBox>
          <DashboardHeader
            description={""}
            title={"Ustawienia"}
            btnText={""}
            btnActive={false}
          />
          <DashboardBoxWrapper>
            <ToggleButton
              text={"Włącz tryb ciemny"}
              active={user?.settings.dark_mode ?? false}
              onToggle={toggleDarkMode}
            />
            <ToggleButton
              text={"Otrzymuj newsletter"}
              active={user?.settings.newsletter ?? false}
              onToggle={toggleNewsletter}
            />
          </DashboardBoxWrapper>
        </DashboardBox>
        */ }
        <DashboardBox>
          <DashboardHeader
            description={
              "Możesz wyłączyć wybrane sekcje, aby nie widzieć treści z nimi związanych na stronie głównej. "
            }
            title={"Wybierz treści, które chcesz widzieć na stronie głównej."}
            btnText={""}
            btnActive={false}
          />
          <DashboardBoxWrapper>
            {/* @ts-ignore */}
            {Object.values(user?.dictionary?.section).map((section) => (
              <ToggleButton
                text={section.name}
                active={
                  !user?.settings.ignored_categories.includes(section.key) ??
                  true
                }
                onToggle={() => onToggleIgnored(section.key)}
              />
            ))}
          </DashboardBoxWrapper>
          {/* <ActionButton
            onClick={() => setModalType(DashboardModalType.MAIN_SETTINGS)}
          >
            Zobacz wszystkie kategorie
          </ActionButton> */}
        </DashboardBox>
      </StyledDashboardWrapper>
    </>
  );
};

const StyledDashboardWrapper = styled("div", {
  marginBottom: "32px",
  "@bp4": {
    marginBottom: "80px",
  },
  "& h2": {
    color: "$grayscale90",
    margin: "0 16px 16px 16px",
    "@bp4": {
      margin: "0 0 16px 0",
    },
  },
  "& p": {
    margin: "0 16px 24px 16px",
    color: "$grayscale75",
    "@bp4": {
      margin: "0 0 24px 0",
    },
  },
});

const DashboardBox = styled("div", {
  background: "$grayscale0",
  borderBottom: "1px solid $grayscale10",
  padding: "0 16px 20px 16px",
  display: "flex",
  flexDirection: "column",
  "@bp4": {
    padding: "0 32px 12px 32px",
    marginBottom: "16px",
    borderBottom: "0px solid $grayscale10",
  },
});

const DashboardBoxWrapper = styled("div", {
  width: "100%",
  "& div": {
    marginBottom: "20px",
    width: "100%",
    "@bp4": {
      width: "324px",
    },
  },
});

const ActionButton = styled("button", {
  color: "$primary",
  background: "none",
  borderWidth: "0px",
  cursor: "pointer",
  marginRight: "auto",
  paddingBottom: "12px",
});

export default DashboardWatched;
